import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT, EVENT_TYPES} from '../../constants/globalConstants'
import { dateFormatter,formatAMPM,formatDateDays, getEventTypeByPassType, getImage } from '../../utils/helper'
import { Circles } from 'react-loader-spinner'


function BillingInformation(props) {

	const { eventType, eventDetails, eventRates, discount, loader } = props
	return (	
		<div className="container">
					<div className="card shadow mb-5">
						<div className="card-header">
							<div className="row align-items-center">
								<div className="col text-start">
									<img width='50px' src={getImage(eventDetails)} />&nbsp; {eventDetails.slug}
								</div>
								<div className="col text-center">
									{eventType == EVENT_TYPES?.EVENT ? dateFormatter(eventDetails?.start_time , 'MMMM DD, YYYY') : null} {eventType == EVENT_TYPES?.EVENT ? ',':null} {eventType == EVENT_TYPES?.EVENT ? formatDateDays(eventDetails?.start_time) : null} {eventType == EVENT_TYPES?.EVENT ? formatAMPM(eventDetails?.start_time) : null}
								</div>
								<div className="col text-end">
								{/* <b>{getEventTypeById(`${eventDetails?.id}`)}</b> */}
								<b>{getEventTypeByPassType(eventDetails?.pass_type_slug, eventDetails?.is_full_season)}</b>
								</div>
							</div>
						</div>	
						<div className="card-body bill-card">
							<div className="row mb-3 align-items-center">
								<div className="col text-start">Parking Price Including Tax
								</div>
                 
								<div className="col text-end">
									${eventType == EVENT_TYPES?.EVENT ? eventDetails?.event_rate : eventDetails?.price}
								</div>
							</div>
							<div className="row mb-3 align-items-center">
								<div className="col text-start">Processing Fee
								</div>
                 
								<div className="col text-end">${eventRates?.tax_rate?.toFixed(2)}
								</div>
							</div>
							{discount !== null && <div className="row mb-3 align-items-center">
								<div className="col text-start">Discount Applied
								</div>
                 
								<div className="col text-end">- ${discount != '' ? discount?.toFixed(2): ''}
								</div>
							</div>}
						</div>
						<div className="card-footer p-3 bg-info bg-opacity-10">
							<div className="row">
								<div className="col text-start">
									<p className="lead fw-bold m-0">Total</p> 
								</div>
								<div className="col text-end">
								{loader ? 
										<span className='d-flex justify-content-end'><Circles
											height="15"
											width="15"
											color="#060D63"
											ariaLabel="circles-loading"
											className="inline"
											visible={true}
										/></span> : 
										<p className="lead m-0 fw-bold">${ eventRates?.amount.toFixed(2)}</p>}
								</div>
							</div>
						</div>
					</div>
					
					<hr/>
		</div>
	)

}

BillingInformation.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	eventType: PropTypes.string,
	eventDetails: PropTypes.object,
	discount: PropTypes.string,
	eventRates: PropTypes.object,
	loader: PropTypes.bool,
	fisrtLoad: PropTypes.bool,
}

BillingInformation.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
    eventType: undefined,
	eventDetails: EMPTY_OBJECT,
	discount: undefined,
	eventRates: EMPTY_OBJECT,
	loader: true,
	fisrtLoad: false,

}

function mapStateToProps({ paymentReducer }) {
	return {
		data: paymentReducer,
	}
}
export default connect(mapStateToProps)(BillingInformation)

